import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON} from "../web/validation";

export const ContainerFillValidator = t.intersection([
  t.type({}),
  t.partial({
    dttm: t.number,
    rate: t.number,
    actualPercent: t.number,
    actualHeight: t.number,
    actualVolume: t.number,
    actualStatus: t.string,
    estimatedPercent: t.number,
    estimatedHeight: t.number,
    estimatedVolume: t.number,
    estimatedStatus: t.string,
  }),
]);

export const ContainerFillArrayValidator = t.array(ContainerFillValidator);

export type ContainerFill = t.TypeOf<typeof ContainerFillValidator>;
export type ContainerFillArray = t.TypeOf<typeof ContainerFillArrayValidator>;


@Exclude()
export class ContainerFillEntity {
  @Expose() dttm?: number
  @Expose() rate?: number
  @Expose() actualPercent?: number
  @Expose() actualHeight?: number
  @Expose() actualVolume?: number
  @Expose() actualStatus?: string
  @Expose() estimatedPercent?: number
  @Expose() estimatedHeight?: number
  @Expose() estimatedVolume?: number
  @Expose() estimatedStatus?: string

  /**
   * Constructor for ContainerFillEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(containerFill: ContainerFill): ContainerFillEntity {
    return plainToInstance(
      ContainerFillEntity,
      containerFill,
      {
        excludeExtraneousValues: true,
      }
    );
  }

  toTypeValue(): Promise<ContainerFill> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ContainerFillValidator, object);
  }
}
